import {
  Alert,
  Button,
  Container,
  Pagination,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import '../App.css';
import '../index.css';
import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';

import ExtraFilters from '../components/object/ExtraFilters';
import SaleTypeSelector from '../components/object/SaleTypeSelector';
import CategorySelector from '../components/object/CategorySelector';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import objectStore from '../stores/objectStore';
import filterStore from '../stores/filterStore';
import { toJS } from 'mobx';
import Modal from '@mui/material/Modal';

import i18nStore from '../stores/i18nStore';
import ObjectCardRu from '../components/object/ObjectCardRu';
import ObjectCardDefault from '../components/object/ObjectCardDefault';

import AddressObject from '../components/object/AddressObject';
import logger from '../utils/logger';
import ObjectSourceObjPage from '../components/ObjectSourceObjPage';
import { IoSearch } from 'react-icons/io5';
import { IoMdOptions } from "react-icons/io";
import apiClient from '../utils/apiClient';
import ModalObjectCard from '../components/object/ModalObjectCard';
import CustomFieldObjectFilter from '../components/customFields/CustomFieldObjectFilter';
import { canMutateResource } from '../tenancy/resourcePermissions';
import {
  organizationStorageKey,
  readOrganizationStorage,
  removeLegacyOrganizationStorage,
} from '../tenancy/organizationStorage';

const ObjectPage = observer(() => {
  // Функция для загрузки сохраненного типа продажи из localStorage
  const loadSaleTypeFromStorage = () => {
    try {
      removeLegacyOrganizationStorage('objectsPage_saleType');
      const savedSaleType = readOrganizationStorage('objectsPage_saleType');
      return savedSaleType || 'all'; // По умолчанию "Все"
    } catch (error) {
      logger.log('Ошибка загрузки из localStorage:', error);
      return 'all'; // По умолчанию "Все" при ошибке
    }
  };

  // Инициализируем с сохраненным значением или "all" по умолчанию
  const [saleTypeParams, setSaleTypeParams] = useState(loadSaleTypeFromStorage());
  const [categoryParams, setCategoryParams] = useState(-1); // Храним id выбранной категории. -1 - Все
  const [subcategoryParams, setSubcategoryParams] = useState([]); // Храним id выбранных подкатегорий

  const [categotyForExtraFilter, setCategotyForExtraFilter] = useState();

  const [categories, setCategories] = useState([]);

  const locale = i18nStore.currentCountry;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // упраление модальным окном и Экстра фильтрами
  const [isModalOpen, setModalOpen] = useState(false);
  const [editorObject, setEditorObject] = useState(null);
  const [editorError, setEditorError] = useState('');
  const [customFieldFilter, setCustomFieldFilter] = useState(null);

  const handleOpenModal = () => {
    logger.log('🏀 ', filterStore.objectPageControls.selectedSubcategories[0]);

    setCategotyForExtraFilter(filterStore.objectPageControls.selectedSubcategories[0].id);
    filterStore.updateSelectedFields();
    setModalOpen(true);
  };

  // удаление объекта
  const handleDelete = async (id) => {
    logger.log(`Начало процесса удаления объекта с ID: ${id}`);
    await objectStore.deleteObject(id); // Вызов функции удаления из стора
    logger.log(`Объект с ID: ${id} успешно удален из стора`);
  };

  const handleCloseModal = () => setModalOpen(false);

  // Очистка дополнительных фильтров
  const clearExtraFilter = () => {
    filterStore.clearExtraFilter();
    getFilteredObjects(); // Обновляем объекты после очистки фильтра
  };

  // Переход на страницу создания объекта
  const navigate = useNavigate();
  const goToNewObject = () => {
    navigate('/newobject');
  };

  useEffect(() => {
    const objectId = new URLSearchParams(window.location.search).get('editObjectId');
    if (!objectId || !/^[1-9]\d*$/.test(objectId)) return;
    let active = true;
    setEditorError('');
    apiClient
      .post('/objects/last-new', { id: objectId })
      .then((response) => {
        const object = response.data?.object;
        if (!active) return;
        if (!object || !canMutateResource(object)) {
          setEditorError('Объект не найден или недоступен для редактирования.');
          return;
        }
        setEditorObject(object);
      })
      .catch(() => {
        if (active) setEditorError('Не удалось открыть объект для редактирования.');
      });
    return () => {
      active = false;
    };
  }, []);

  // точка сбора данных для фильтрации и отправка в mobx стор
  useEffect(() => {
    objectStore.setSaleType(saleTypeParams);
    objectStore.setActiveCategoryId(categoryParams);
    objectStore.setSelectedSubcategories(subcategoryParams);
  }, [saleTypeParams, categoryParams, subcategoryParams]);

  const saleTypeHandler = (saleType) => {
    setSaleTypeParams(saleType);
  };

  const onSelectionChangeCategory = ({ category, subcategories }) => {
    const plainCategory = category ? toJS(category) : -1;
    const plainSubcategories = subcategories.length
      ? subcategories.map((sub) => toJS(sub))
      : plainCategory
      ? plainCategory.subcategories.map((sub) => toJS(sub))
      : [];

    setCategoryParams(plainCategory ? { id: plainCategory.id } : -1);
    setSubcategoryParams(plainSubcategories.map((sub) => ({ id: sub.id })));

    logger.log('🎀 Category Selected:', plainCategory);
    logger.log('🎀 Subcategories Selected:', plainSubcategories);
  };

  // загружать, если ничего не загружено
  useEffect(() => {
    // Загружаем данные только при первой загрузке
    if (objectStore.objects.length === 0) {
      filterStore.fetchFOfromObjectPage();
    }
  }, []);

  useEffect(() => {
    objectStore.fetchCategoriesAndFiles('RU'); // Загружаем данные только при необходимости
    setCategories(objectStore.categories);
  }, []);

  const getFilteredObjects = () => {
	filterStore.setCustomFieldFilters(customFieldFilter?.definitionId ? [customFieldFilter] : []);
    filterStore.fetchFOfromObjectPageConfirmBtn();
  };

  const handlePageChange = (event, page) => {
    logger.log(`Switching to page: ${page}`);
    filterStore.fetchFOFromPagination(page);
  };

  // Проверяем, есть ли данные в extraFilter
  const hasExtraFilter = Object.keys(filterStore.extraFilter).length > 0;

  return (
    <div>
      {import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && (
        <div onClick={() => logger.log('ObjectsPage Render')}>% ObjectsPage %</div>
      )}

      <Container className="mt-5">
		{filterStore.searchError && <Alert severity="warning" sx={{ mb: 2 }}>{filterStore.searchError}</Alert>}
        {editorError && <Alert severity="error" sx={{ mb: 2 }}>{editorError}</Alert>}
        <Button
          size="medium"
          color="primary"
          variant="contained"
          startIcon={<AddIcon />}
          onClick={goToNewObject}>
          {i18nStore.translations.buttons.create_new_property}
          {/* Создать новый объект */}
        </Button>
        <hr className="my-3" />

        <Typography variant="h6" className="mt-5">
          Фильтры
        </Typography>
        <div className="mt-1">
          {/* Селектор типа продажи с сохранением выбора в localStorage */}
          <SaleTypeSelector
            saleTypeHandler={saleTypeHandler}
            initialSelectedType={saleTypeParams}
            shouldPersist={true}
            persistKey={organizationStorageKey('objectsPage_saleType')}
          />{' '}
          {/* Продажа, Аренда */}
          <div className="mt-5">
            <CategorySelector onSelectionChange={onSelectionChangeCategory} />
          </div>
          <div className="mt-2 mb-5">
			<CustomFieldObjectFilter value={customFieldFilter} onChange={setCustomFieldFilter} />
            {filterStore.objectPageControls.selectedSubcategories.length === 1 && (
              <Button
                onClick={handleOpenModal}
                variant="outlined"
                color="primary"
                size="small"
                sx={{ marginRight: '10px' }}>
                Расширенный фильтр <IoMdOptions className="ml-2" />
              </Button>
            )}

            {hasExtraFilter && (
              <Button
                onClick={clearExtraFilter}
                variant="outlined"
                color="secondary"
                size="small"
                sx={{ marginLeft: '0px' }}>
                Сбросить фильтр
              </Button>
            )}
            <div className="mt-5">
              <AddressObject />
            </div>

            <div className="mt-5">
              <ObjectSourceObjPage />
            </div>

            <Modal open={isModalOpen} onClose={handleCloseModal}>
              <Box
                sx={(theme) => ({
                  position: 'absolute',
                  top: '2%', // Уменьшаем отступ сверху с 5% до 2%
                  left: '50%',
                  transform: 'translate(-50%, 0)',
                  width: '97%', // Базовый размер для мобильных устройств
                  bgcolor: 'background.paper',
                  boxShadow: 24,
                  p: 2,
                  borderRadius: 1, // Скругление краев
                  maxHeight: '96vh', // Увеличиваем максимальную высоту с 95vh до 96vh
                  overflowY: 'hidden', // Убираем прокрутку у самого модального окна, т.к. прокрутка уже есть в компоненте

                  // Адаптивные размеры для разных экранов
                  [theme.breakpoints.up('sm')]: {
                    width: '80%', // Для небольших экранов, таких как планшеты
                  },
                  [theme.breakpoints.up('md')]: {
                    width: '70%', // Для средних экранов, таких как ноутбуки
                  },
                  [theme.breakpoints.up('lg')]: {
                    width: '60%', // Для больших экранов
                  },
                  [theme.breakpoints.up('xl')]: {
                    width: '50%', // Для очень больших экранов
                  },
                })}>
                <ExtraFilters
                  categoryId={categotyForExtraFilter}
                  source={'objectpage'}
                  onClose={handleCloseModal}
                />
              </Box>
            </Modal>
          </div>
          <div>
            <span>
              {/* 		<Button
								color='inherit'
								variant='outlined'
								onClick={getFilteredObjects}
							>
								Сбросить
							</Button> */}
            </span>
            <span className="">
              <Button color="secondary" variant="outlined" onClick={getFilteredObjects}>
                Поиск <IoSearch className="ml-2" />
              </Button>
            </span>
          </div>
        </div>

        <div className="flex justify-center">
          {/* Пагинация */}
          <Pagination
            count={objectStore.totalPages}
            page={objectStore.currentPage}
            onChange={handlePageChange}
            showFirstButton
            showLastButton
            siblingCount={1} // Показывает по одной цифре рядом с текущей страницей
            boundaryCount={1} // Показывает по одной цифре в начале и конце
            className="mt-5"
          />
        </div>
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {objectStore.objects
              .slice() // Создаем копию массива, чтобы не мутировать оригинальный стейт
              .sort((a, b) => {
                // Permission-bearing resources are rendered before read-only
                // resources; ownership IDs are never an authorization signal.
                if (canMutateResource(a) && !canMutateResource(b)) return -1;
                if (!canMutateResource(a) && canMutateResource(b)) return 1;

                // Затем сортируем по updatedAt (свежее — выше)
                return new Date(b.updatedAt) - new Date(a.updatedAt);
              })
              .map((object) =>
                locale === 'RU' ? (
                  <ObjectCardRu
                    key={object.id}
                    object={object}
                    locale={locale}
                    onDelete={handleDelete}
                    viewMode="card"
                  />
                ) : (
                  <ObjectCardDefault
                    key={object.id}
                    object={object}
                    locale={locale}
                    onDelete={handleDelete}
                    viewMode="card"
                  />
                ),
              )}
          </div>
        </div>
        <Modal
          open={Boolean(editorObject)}
          onClose={() => {
            setEditorObject(null);
            navigate('/objects', { replace: true });
          }}>
          <Box
            sx={{
              position: 'absolute',
              top: '5%',
              left: '50%',
              transform: 'translate(-50%, 0)',
              width: { xs: '97%', md: '70%' },
              bgcolor: 'background.paper',
              boxShadow: 24,
              borderRadius: 3,
              maxHeight: '95vh',
              overflowY: 'auto',
              p: 2,
            }}>
            {editorObject && (
              <ModalObjectCard
                object={editorObject}
                initialEditOpen
                onClose={() => {
                  setEditorObject(null);
                  navigate('/objects', { replace: true });
                }}
                onDelete={handleDelete}
              />
            )}
          </Box>
        </Modal>

        {/* 	</Grid2> */}
        <div className="flex justify-center">
          <div className="mt-3 mb-10">
            <Pagination
              count={objectStore.totalPages}
              page={objectStore.currentPage}
              onChange={handlePageChange}
              showFirstButton
              showLastButton
              siblingCount={1} // Показывает по одной цифре рядом с текущей страницей
              boundaryCount={1} // Показывает по одной цифре в начале и конце
              className="mt-5"
            />
          </div>
        </div>
      </Container>
    </div>
  );
});

export default ObjectPage;
